import axios from 'CanExConfig/axios'

export const searchCandidateSkills = async (term, categories) => {
  const response = await axios('/search/skills', {
    method: 'GET',
    params: {
      term,
      category: categories,
    },
  })
  return response.data
}
